import React from 'react'

import { EmptyResultWrap, IconWrap, Title, BodyText } from './styled'

interface Props {
  icon?: React.FC
  title: string
  body: string
  footer?: React.FC
}

export const EmptyState: React.FC<Props> = ({
  icon: Icon,
  title,
  body,
  footer: Footer,
}) => (
  <EmptyResultWrap>
    {Icon && (
      <IconWrap>
        <Icon />
      </IconWrap>
    )}
    <Title>{title}</Title>
    <BodyText>{body}</BodyText>
    {Footer && <Footer />}
  </EmptyResultWrap>
)
